module.exports = __webpack_public_path__ + "web-assets/img/img_tsg_bg.0fc1da1f.png";